<payee-popup title="Új hitelező">
  @if (initLoading()) {
    <mat-progress-spinner
      color="accent"
      mode="indeterminate"
      diameter="100"
    ></mat-progress-spinner>
  }
  <form [formGroup]="formGroup">
    <payee-form-field width="max">
      <span payee-label>Név</span>
      <input
        payee-input
        formControlName="name"
        [matAutocomplete]="auto"
        (input)="onCompanySearchInput($event)"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        [requireSelection]="false"
        (optionSelected)="companySelected($event)"
      >
        @for (option of autocompleteOptions; track option.tax_number || option.name) {
          <mat-option [value]="option">
            {{ option.name }}
          </mat-option>
        }
      </mat-autocomplete>
    </payee-form-field>

    <payee-form-field width="max">
      <span payee-label>Hitelező adószáma</span>
      <input
        payee-input
        formControlName="tax_number"
      />
      @if (tax_number.dirty) {
        <ng-container payee-error>
          @if (tax_number.hasError("required")) {
            <span>A mező kitöltése kötelező</span>
          }
          @if (tax_number.hasError("backend")) {
            <span>
              {{ tax_number.getError("backend") }}
            </span>
          }
        </ng-container>
      }
    </payee-form-field>

    <form formGroupName="address">
      <h2>{{ name.value || "Hitelező" }} kézbesítési címe</h2>

      @if (countryOptions.length) {
        <payee-form-field width="max">
          <span payee-label>Ország</span>
          <payee-autocomplete
            formControlName="country"
            [options]="countryOptions"
            [displayWith]="countryDisplayWith"
          ></payee-autocomplete>
          @if (country.dirty && country.invalid) {
            <ng-container payee-error>
              @if (country.hasError("required")) {
                <span>A mező kitöltése kötelező</span>
              }
              @if (country.hasError("backend")) {
                <span>
                  {{ country.getError("backend") }}
                </span>
              }
            </ng-container>
          }
        </payee-form-field>
      }

      <div
        class="flex"
        style="justify-content: space-between"
      >
        <payee-form-field style="--width: 192px">
          <span payee-label>Irányítószám</span>
          <input
            payee-input
            formControlName="postcode"
          />
          @if (postcode.dirty) {
            <ng-container payee-error>
              @if (postcode.hasError("required")) {
                <span>A mező kitöltése kötelező</span>
              }
            </ng-container>
          }
        </payee-form-field>

        <payee-form-field style="--width: 192px">
          <span payee-label>Település</span>
          <input
            payee-input
            formControlName="settlement"
          />
          @if (settlement.dirty) {
            <ng-container payee-error>
              @if (settlement.hasError("required")) {
                <span>A mező kitöltése kötelező</span>
              }
            </ng-container>
          }
        </payee-form-field>
      </div>

      <payee-form-field width="max">
        <span payee-label>Utca és házszám</span>
        <input
          payee-input
          formControlName="street"
        />
        @if (street.dirty) {
          <ng-container payee-error>
            @if (street.hasError("required")) {
              <span>A mező kitöltése kötelező</span>
            }
          </ng-container>
        }
      </payee-form-field>
    </form>

    <payee-form-field width="max">
      <span payee-label>Hitelező típusa</span>
      <payee-autocomplete
        formControlName="party_type_id"
        [options]="partyTypeOptions"
        [displayWith]="partyTypeDisplayWith"
      ></payee-autocomplete>
      @if (party_type_id.dirty && party_type_id.invalid) {
        <ng-container payee-error>
          @if (party_type_id.hasError("required")) {
            <span>A mező kitöltése kötelező</span>
          }
          @if (party_type_id.hasError("backend")) {
            <span>
              {{ party_type_id.getError("backend") }}
            </span>
          }
        </ng-container>
      }
    </payee-form-field>
    <!-- Errors that didn't match any fields in the form -->
    @if (formGroup.dirty && formGroup.invalid) {
      <div
        color="alert-red"
        payee-error
      >
        @if (formGroup.hasError("backend")) {
          <span>
            {{ formGroup.getError("backend") }}
          </span>
        }
      </div>
    }
  </form>
  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="formGroup.invalid"
      (click)="submit()"
    >
      Mentés
    </button>
  </ng-template>
  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="alert-red"
      width="max"
      mat-dialog-close=""
    >
      Mégse
    </button>
  </ng-template>
</payee-popup>
